// Coordenadas aproximadas dos limites de Frecheirinha, Ceará
// Polígono simplificado cobrindo a área municipal
export const FORTALEZA_BOUNDARIES = [
  { lat: -3.7012, lng: -40.8823 }, // Noroeste
  { lat: -3.7134, lng: -40.8512 }, // Norte
  { lat: -3.7245, lng: -40.7989 }, // Nordeste
  { lat: -3.7589, lng: -40.7656 }, // Leste
  { lat: -3.8123, lng: -40.7512 }, // Sudeste
  { lat: -3.8456, lng: -40.7823 }, // Sul
  { lat: -3.8512, lng: -40.8345 }, // Sudoeste
  { lat: -3.8234, lng: -40.8756 }, // Oeste
  { lat: -3.7756, lng: -40.8912 }, // Noroeste 2
  { lat: -3.7345, lng: -40.8889 }, // Fechamento
];

/**
 * Verifica se um ponto está dentro de um polígono usando o algoritmo Ray Casting
 * @param point Ponto a ser verificado
 * @param polygon Array de coordenadas do polígono
 * @returns true se o ponto está dentro do polígono
 */
export const isPointInPolygon = (
  point: { lat: number; lng: number },
  polygon: { lat: number; lng: number }[]
): boolean => {
  let inside = false;
  const x = point.lng;
  const y = point.lat;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lng;
    const yi = polygon[i].lat;
    const xj = polygon[j].lng;
    const yj = polygon[j].lat;

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }

  return inside;
};

/**
 * Verifica se uma localização está dentro dos limites de Frecheirinha
 * @param location Localização a ser verificada
 * @returns true se está dentro dos limites
 */
export const isLocationInFortaleza = (location: {
  lat: number;
  lng: number;
}): boolean => {
  return isPointInPolygon(location, FORTALEZA_BOUNDARIES);
};
